routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.category', {
      url: __env.routes.category,
      template: `<category sh-ctrl="shCtrl"></category>`
    })
    .state('home.categorySlug', {
      url: __env.routes.categorySlug,
      template: `<category sh-ctrl="shCtrl"></category>`
    })
    .state('home.categoryId', {
      url: __env.routes.categoryId,
      template: `<category sh-ctrl="shCtrl"></category>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category.config.js
 **/